import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-no.svg";
import * as styles from "./Icon.module.scss";

type IconNoProps = React.SVGProps<SVGSVGElement>;

export const IconNo = ({ className, ...props }: IconNoProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
